import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
  Table,
} from "reactstrap";
import "./index.css";
import { useTab } from "@mui/base";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../../Icons/Icons";
import DatePicker from "react-datepicker";
import { DatePickerField } from "../../../core/inputs/input";
import { useRef } from "react";
import AddFreight from "../../../TripsMainV2/Components/AddFreight";
import { getDriverList } from "../../../../services/Store/Actions/driverslistActions";
import {
  createTrip,
  getCityAndState,
} from "../../../../services/Store/Actions/TripsAction";
import moment from "moment";
import {
  addPaymentRecivedAction,
  collectPaymentAction,
  createLogipeInvoiceAction,
  getCustomerAction,
  getInvoiceNoAction,
  getLedgerListAction,
} from "../../../../services/Store/Actions/customerAction";
import InvoiceToast from "../../../subComponents/InvoiceToast";
import { toastStatus } from "../../../../services/Store/Actions/appActions";
import ManuallyInvoice from "../ManualInvoice";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import NotesModal from "../NotesModal";
import { parse } from "date-fns";
import FormPicker from "../../../core/FormPicker";
import SelectVendorModal from "../SelectVendorModal";
import LedgerList from "../LedgerList";
import AddLedgerEntry from "../addLedgerEntry";
import ConfirmationModal from "../../../Modals/confirmModalInvoice";
import InvoiceSettingModal from "../InvoiceSetting";

function TripInvoiceDetail(props) {
  const {
    toggle,
    modal,
    setModal,
    isCheck,
    tripSelect,
    discountPercent,
    setDiscountPercent,
    discount,
    setDiscount,
    taxesIGST,
    settaxesIGST,
    taxesIGSTPercent,
    settaxesIGSTPercent,
    taxesCGST,
    settaxesCGST,
    taxesCGSTPercent,
    settaxesCGSTPercent,
    subTotal,
    setsubTotal,
    total,
    setTotal,
    quantity,
    setQuantity,
    tripInvoice,
    customerId,
    setIgstAdded,
    setCgstAdded,
    igstAdded,
    cgstAdded,
    setSgstAdded,
    sgstAdded,
    taxesSGST,
    settaxesSGST,
    taxesSGSTPercent,
    settaxesSGSTPercent,
    handleClosePre,
    setExtraCharges,
    extraCharges,
    chargesFormValues,
    setChargesFormValues,
    extraTotal,
    setExtraTotal,
    deductionFormValues,
    setDeductionFormValues,
    deductionTotal,
    setDeductionTotal,
    extraDeduction,
    setExtraDeduction,
    invoiceNo,
    setInvoiceNo,
    invoiceDate,
    setInvoiceDate,
    lrDataFormValue,
    setLrDataFormValue,
    lrDescription,
    setLrDescription,
    finalTotal, 
    setFinalTotal,
  } = props;
  const { customer } = useSelector((state) => state?.customer);
  const [selectManually, setSelectManually] = useState(false);
  const [selectTransactionModal, setSelectTransactionModal] = useState(false);
  const [addLedger, setAddLedger] = useState(false);
  const toastObject = useSelector((state) => state?.app?.toastObject);
  const [loader, setLoader] = useState(false);
  const [radioBtn, setRadioBtn] = useState(true);
  const [extra, setExtra] = useState(0);
  const [tripDetail, setTripDetail] = useState(false);
  const [notesModal, setNotesModal] = useState(false);
  const [textNote, setTextNote] = useState("");
  const [openToast, setOpenToast] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [link, setLink] = useState("");
  const [display, setDisplay] = useState(false);
  const [color, setColor] = useState(-1);
  const [search, setSearch] = useState("");
  const [ledger, setLedger] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [version, setVersion] = useState(null);
  const [fetchInvoiceNo, setFetchInvoiceNo] = useState("");

  const [inovieSetting, setInovieSetting] = useState(false);

  const [editLrData, setEditLrData] = useState(false);
  const [discountPercentFinally, setDiscountPercentFinally] = useState(true)
  const [igstPercentFinally, setIgstPercentFinally] = useState(true)
  const [cgstPercentFinally, setCgstPercentFinally] = useState(true)
  const [sgstPercentFinally, setSgstPercentFinally] = useState(true)
  const [taxable, setTaxable] = useState(false)
  console.log("lrDataFormValue",lrDataFormValue, "deductionFormValues",deductionFormValues, "chargesFormValues",chargesFormValues);
  let handleChangeField = (i, e, lrNo) => {
    if(parseFloat(e.target.value) < 1) return 
    let newFormValues = {...lrDataFormValue};
    console.log("handleChangeField111", total,newFormValues[lrNo][i], newFormValues[lrNo][i]?.quantity, newFormValues[lrNo][i]?.amountPerQuantity);
    let x = 0
    // if(newFormValues[lrNo][i]?.quantity && newFormValues[lrNo][i]?.amountPerQuantity){
    newFormValues[lrNo].forEach(el => x = x + ((parseFloat(el?.quantity) || 0 ) * (parseFloat(el?.amountPerQuantity) || 0)) )
    // }
    newFormValues[lrNo][i][e.target.name] = e.target.value;
    console.log("handleChangeField222", newFormValues);
    setLrDataFormValue(newFormValues);
    let y = 0
    newFormValues[lrNo].forEach(el => {
      console.log("removeFormFields333",total, x, y,total - x + y );
        y = y + ((parseFloat(el?.quantity) || 0 ) * (parseFloat(el?.amountPerQuantity) || 0)) 
    })
    setTotal(total - x + y)
  };
  let removeFormFields = (index, lrNo) => {
    console.log("removeFormFields111", total);

    let newFormValues = {...lrDataFormValue};
    let x = 0
    // if(newFormValues[lrNo][index]?.quantity && newFormValues[lrNo][index]?.amountPerQuantity){
    newFormValues[lrNo].forEach(el => x = x + ((el?.quantity || 0 ) * (el?.amountPerQuantity || 0)) )
    // }
    let lrData = lrDataFormValue[lrNo]
    lrData = lrData.filter((e , i ) => i != index)
    newFormValues[lrNo] = lrData
    console.log("removeFormFields222", newFormValues, newFormValues[lrNo][index]?.quantity, newFormValues[lrNo][index]?.amountPerQuantity);
    setLrDataFormValue(newFormValues);
    let y = 0
    newFormValues[lrNo].forEach(el => {
      console.log("removeFormFields333",total, x, y,total - x + y );
      y = y + ((el?.quantity || 0 ) * (el?.amountPerQuantity || 0)) 
    })
    setTotal(total - x + y)

  };
  let addFormFields = (lrNo) => {
    console.log("===><<<><><", lrDataFormValue);
    let newFormValues = {...lrDataFormValue};
    let lrData = newFormValues[lrNo]
    if(lrData?.length > 0) lrData.push({ desc: "", quantity: "", weightPerQuantity: "", amountPerQuantity: "" })
    else lrData = [{ desc: "", quantity: "", weightPerQuantity: "", amountPerQuantity: "" }]
    
    newFormValues[lrNo] = lrData
    console.log("lrDataFormValue",lrDataFormValue);
    setLrDataFormValue(newFormValues);
  };
  // console.log("==subTota11111l== ", deductionFormValues);

  console.log("====isCheck11=====", tripSelect);
  // const handleSelectManually = () => {
  //   console.log("=======mmm", !selectManually);
  //   setSelectManually(!selectManually);
  // };

  useEffect(() => {
    if (
      customerId !== undefined &&
      customerId !== "" &&
      selectTransactionModal
    ) {
      dispatch(
        getLedgerListAction({
          customerId: customerId,
          offset: 0,
          search: "",
          transferType: "unused",
          sortAs: "",
          sortBy: "",
          limit: 4,
        })
      );
    }
  }, [selectTransactionModal]);

  useEffect(() => {
    dispatch(
      getInvoiceNoAction({}, (res) => {
        console.log("jsdjnifjeirj",res?.data)
        setFetchInvoiceNo(res?.data?.data)
      },null,null,"1")
    );
  },[])

  const addChargesToAll = (charges, index, lrNo ) => () => {
    console.log("addChargesToAll", charges, index,lrNo,chargesFormValues);
    if(!charges.amount || !charges.remarks || (charges.remarks == "Detention" && !charges.diffDays)){
      return;
    }
    let x = 0;
    let newFormValues = {...chargesFormValues};
    tripSelect.forEach((elem) => {
      console.log("addChargesToAll.forEach111", elem?.lrNo,newFormValues[elem?.lrNo]);
      if (lrNo != elem?.lrNo) {
        if(newFormValues[elem?.lrNo] && newFormValues[elem?.lrNo].length > 0){
          newFormValues[elem?.lrNo].push(charges);
        }else{
          newFormValues[elem?.lrNo] = [charges]
        }
      console.log("addChargesToAll.forEach222", elem?.lrNo,newFormValues[elem?.lrNo]);
        x = x + (parseFloat(charges?.amount || 0) * parseFloat(charges?.diffDays || 1))
      }
    })
    setChargesFormValues(newFormValues);
    setTotal(total+x)
    setExtraTotal(extraTotal+x);
    console.log("addChargesToAll",chargesFormValues, newFormValues);
    return
  }
 
  let removeChargesFormFields = (index, lrNo) => {
    console.log("removeChargesFormFields", lrNo, index);
    let earlierChargesT = parseFloat(extraTotal || 0)
    let newFormValues = {...chargesFormValues};
    let charges = newFormValues[lrNo]
    let x = 0
    charges?.map((el) => (x =
      x +
      parseFloat(el?.amount || 0) *
        parseFloat(el?.diffDays || 1)));
    console.log("handleChangeFieldCharges222",charges,earlierChargesT,x);

    if (charges?.length == 1) {
      charges = {lrNo: []}
    } else {
      charges = charges.filter((e , i ) => i != index)
    }
    let y = 0;
    newFormValues[lrNo] = charges
    if (charges?.length > 0){
      charges?.map((el) => (y =
        y +
        parseFloat(el?.amount || 0) *
          parseFloat(el?.diffDays || 1)));
    }
    console.log("handleChangeFieldCharges333",earlierChargesT,x,y );
    setExtraTotal(earlierChargesT - x + y);
    setTotal(total + ( - x + y))
    setChargesFormValues(newFormValues);
    console.log("removeChargesFormFields", charges);
  };
  let handleChangeFieldCharges = (i, e, lrNo) => {
    console.log("handleChangeFieldCharges111", i,e.target.name ,e.target.value, lrNo, extraTotal);
    if(parseFloat(e.target.value) < 1) return 
    let earlierChargesT = parseFloat(extraTotal || 0)
    let newFormValues = {...chargesFormValues};
    let charges = newFormValues[lrNo]
    let x = 0
    let y = 0;
    charges?.map((el) => (x =
      x +
      parseFloat(el?.amount || 0) *
        parseFloat(el?.diffDays || 1)));
    console.log("handleChangeFieldCharges222",charges,earlierChargesT,x ,y);
    charges[i][e.target.name] = e.target.value;
    if (e.target.name == "amount") {
      charges.map(
        (el) =>
          (y =
            y +
            parseFloat(el?.amount || 0) *
              parseFloat(el?.diffDays || 1))
      );
      setExtraTotal(earlierChargesT - x + y);
    }
    console.log("handleChangeFieldCharges333",earlierChargesT,x,y );

    if (e.target.name == "diffDays") {
      charges.map(
        (e) =>
          (y =
            y +
            parseFloat(e?.diffDays || 1) *
              parseFloat(charges[i]?.amount || 0))
      );
      setExtraTotal(earlierChargesT - x + y);
    }
    console.log("handleChangeFieldCharges444",total,earlierChargesT,x,y,total + (earlierChargesT - x + y) - parseFloat(deductionTotal) );
    newFormValues[lrNo] = charges
    setChargesFormValues(newFormValues);
    if(e.target.name != "remarks")
      setTotal(total + ( - x + y) )
  };
  let addFormFieldsCharges = (lrNo) => {
    let newFormValues = {...chargesFormValues};
    let temp = newFormValues[lrNo]
    console.log("addFormFieldsCharges", temp);
    if(temp?.length > 0)
      temp.push({ remarks: "", amount: 0 });
    else temp = [{ remarks: "", amount: 0 }]
    newFormValues[lrNo] = temp
    setChargesFormValues(newFormValues);
  };

  let removeDeductionFormFields = (index, lrNo) => {
    console.log("removeDeductionFormFields111", lrNo, index);
    let earlierDeductionT = parseFloat(deductionTotal || 0)
    let newFormValues = {...deductionFormValues};
    let deductions = newFormValues[lrNo]
    let x = 0
    console.log("removeDeductionFormFields222", deductions,earlierDeductionT);
    deductions?.map((e) => (x = x + parseFloat(e?.amt || 0)));
    if (deductions?.length == 1) {
      deductions = {lrNo: []}
    } else {
      deductions = deductions.filter((e , i ) => i != index)
    }
    console.log("removeDeductionFormFields333", deductions);
    let y = 0;
    newFormValues[lrNo] = deductions
    if (deductions?.length > 0){
      deductions?.map((e) => (y = y + parseFloat(e?.amt || 0)));
    }
    setDeductionTotal(earlierDeductionT - x + y);
    setTotal(total - ( - x + y) )
    setDeductionFormValues(newFormValues);
    console.log("newFormValues", deductions);
  };
  let handleChangeFieldDeduction = (i, e, lrNo) => {
    if(parseFloat(e.target.value) < 1) return 
    console.log("handleChangeFieldDeductionhandleChangeFieldDeduction", i, e, lrNo);
    let earlierDeductionT = parseFloat(deductionTotal || 0)
    let newFormValues = {...deductionFormValues};
    let deductions = newFormValues[lrNo]
    let x = 0
    let y = 0;
    deductions?.map((el) => (x = x + parseFloat(el?.amt || 0)));
    deductions[i][e.target.name] = e.target.value;
    newFormValues[lrNo] = deductions
    deductions?.map((e) => (y = y + parseFloat(e?.amt || 0)));
    setDeductionTotal(earlierDeductionT - x + y);
    setDeductionFormValues(newFormValues);
    if(e.target.name != "txt")
      setTotal(total - ( - x + y)  )
  };
  let addFormFieldsDeduction = (lrNo) => {
    let newFormValues = {...deductionFormValues};
    let temp = newFormValues[lrNo]
    if(temp?.length > 0)
      temp.push({ txt: "", amt: 0 });
    else temp = [{ txt: "", amt: 0 }]
    newFormValues[lrNo] = temp
    console.log("addFormFieldsDeduction",newFormValues);
    setDeductionFormValues(newFormValues);
  };
  const addDeductionsToAll = (deductions, index, lrNo) => () => {
    console.log("addDeductionsToAll", deductions, index,lrNo,deductionFormValues);
    if(!deductions.amt || !deductions.txt ){
      return;
    }
    let x = 0;
    let newFormValues = {...deductionFormValues};
    tripSelect.forEach((elem) => {
      console.log("addDeductionsToAll.forEach111", elem?.lrNo,newFormValues[elem?.lrNo]);
      if (lrNo != elem?.lrNo) {
        if(newFormValues[elem?.lrNo] && newFormValues[elem?.lrNo].length > 0){
          newFormValues[elem?.lrNo].push(deductions);
        }else{
          newFormValues[elem?.lrNo] = [deductions]
        }
        console.log("addDeductionsToAll.forEach222", elem?.lrNo,newFormValues[elem?.lrNo]);
        x = x + parseFloat(deductions?.amt)
      }
    })
    setDeductionFormValues(newFormValues);
    setTotal(total- x)
    setDeductionTotal(extraTotal+x);
    console.log("addDeductionsToAll",deductionFormValues, newFormValues);
    return
  }
  // useEffect(() => {
  //   // setQuantity("0");
  //   setsubTotal("0");
  //   setTotal("0");
  //   // let ss = 0;
  //   console.log("useEffecttripSelectaaaaa", tripSelect,total, extraTotal,deductionTotal);

  //   // let set = tripSelect?.map((items, i) => {
  //   setQuantity(tripSelect.length);
  //   //   console.log("ititemsems", items);
  //   //   ss += items?.freightAmount || 0;
  //   // });
  //   // console.log("ititemsemsss", ss);
  //   setsubTotal(
  //     parseFloat(total) + parseFloat(extraTotal || 0) - parseFloat(deductionTotal || 0)
  //   );
  //   setTotal(
  //     parseFloat(total) + parseFloat(extraTotal || 0) - parseFloat(deductionTotal || 0)
  //   );
  //   console.log("useEffecttripSelectaaaaa", subTotal, total, deductionTotal, extraTotal);
  // }, [tripSelect, extraTotal, deductionTotal]);
  console.log("====>>>>>>", total);

  useEffect(() => {
    console.log("total, discountPercent, radioBtn, taxable", total, discountPercent, radioBtn, taxable,"extraTotal",extraTotal,"deductionTotal",deductionTotal );
    let finalTotal = (!taxable ? (parseFloat(total) - parseFloat(extraTotal) + parseFloat(deductionTotal)) :  parseFloat(total))
    let discount = 0;
    let igst = 0;
    let cgst = 0;
    let sgst = 0;
    if(discountPercentFinally){
      discount =  finalTotal * (parseFloat(discountPercent || 0) / 100);
      finalTotal = finalTotal - discount
      setDiscount(discount)
    }
    if(radioBtn && igstPercentFinally){
      igst =  finalTotal * (parseFloat(taxesIGSTPercent || 0) / 100);
      finalTotal = finalTotal - igst
      settaxesIGST(igst)
    }
    if(!radioBtn && cgstPercentFinally){
      cgst =  finalTotal * (parseFloat(taxesCGSTPercent || 0) / 100);
      finalTotal = finalTotal - cgst
      settaxesCGST(cgst)
    }
    if(!radioBtn && sgstPercentFinally){
      sgst =  finalTotal * (parseFloat(taxesSGSTPercent || 0) / 100);
      finalTotal = finalTotal - sgst
      settaxesSGST(sgst)
    }
    setFinalTotal(finalTotal);
  }, [total, discountPercent, radioBtn, taxable]);
  const handleClose = () => {
    setDiscountPercent("");
    setDiscount("");
    setExtraCharges("");
    settaxesIGST("");
    settaxesIGSTPercent("");
    settaxesCGST("");
    settaxesCGSTPercent("");
    settaxesSGST("");
    settaxesSGSTPercent("");
    setQuantity("");
    setsubTotal("");
    setTotal("");
    setIgstAdded(false);
    setCgstAdded(false);
    setSgstAdded(false);
    setModal(!modal);
    setChargesFormValues({});
    setExtraTotal(0);
    setExtraDeduction("0");
    setDeductionFormValues({});
    setDeductionTotal(0);
    setLedger([]);
    setInvoiceNo("")
  };
  function toggleTripDetail() {
    setTripDetail(!tripDetail);
  }

  const handleToast = (version) => {
    if (!loader) {
      setLoader(true);
      for (let index = 0; index < tripSelect.length; index++) {
        const element = tripSelect[index];
        element.ExtraCharges = chargesFormValues[element?.lrNo];
        let charges = deductionFormValues[element?.lrNo];
        let x = [];
        let chTotal = 0;
        if(charges?.length > 0) {
            charges.map((e) => {
            chTotal = chTotal + parseFloat(e?.amt);
            x.push({ remarks: e?.txt, amount: e?.amt });
          });
        }
        const lrData = lrDataFormValue[element?.lrNo];
        let totalFreightAmt = 0;
        if(lrData.length > 0){
          lrData.map((e) => {
            totalFreightAmt = totalFreightAmt + (parseFloat(e?.quantity || 1) * parseFloat(e?.amountPerQuantity || 0));
          });
        }
        element.lrData = lrDataFormValue[element?.lrNo];
        element.freightAmount = totalFreightAmt;
        element.chargesData = x;
        element.charges = chTotal;
        element.description = lrDescription[element?.lrNo];
      }
      console.log("kjhihihse", tripSelect);
      const handleCloseToast = () => {
        handleClosePre();
        handleClose();
        dispatch(
          getLedgerListAction({
            customerId: customerId,
            offset: 0,
            search: "",
            transferType: "",
            sortAs: "",
            sortBy: "",
            from: "",
            to: "",
          })
        );
        dispatch(
          toastStatus({
            toastStatus: false,
          })
        );
      };
      const toggleModalToast = () => {
        handleClosePre();
        handleClose();
        dispatch(
          getLedgerListAction({
            customerId: customerId,
            offset: 0,
            search: "",
            transferType: "",
            sortAs: "",
            sortBy: "",
            from: "",
            to: "",
          })
        );
        dispatch(
          toastStatus({
            toastStatus: false,
          })
        );
      };

      dispatch(
        createLogipeInvoiceAction(
          {
            customerId,
            amount: taxable ? total.toString() : (parseFloat(total) - parseFloat(extraTotal) + parseFloat(deductionTotal)).toString(),
            cgst: radioBtn || cgstAdded ? 0 : taxesCGST,
            cgstPercent: radioBtn || cgstAdded ? 0 : taxesCGSTPercent,
            igst: !radioBtn || igstAdded ? 0 : taxesIGST,
            igstPercent: !radioBtn || igstAdded ? 0 : taxesIGSTPercent,
            sgst: radioBtn || sgstAdded ? 0 : taxesSGST,
            sgstPercent: radioBtn || sgstAdded ? 0 : taxesSGSTPercent,
            taxable: taxable,
            discount: discount,
            extraCharges: extraCharges,
            discountPercent: discountPercent,
            tripInvoice: tripInvoice,
            detailsArray: tripSelect,
            textNote: textNote,
            customer: customer,
            advanceCollected: ledger,
            version : version,
            invoiceNo : invoiceNo || "",
            invoiceDate: moment(invoiceDate).format("DD/MM/YYYY") || moment().format("DD/MM/YYYY")
          },
          (resp) => {
            setLoader(false);
            console.log("==>>>resp?.link>>>", resp);
            setLink(resp?.link);
            dispatch(
              getCustomerAction({
                customerId: customer?.customerId,
              })
            );
          },
          handleCloseToast,
          toggleModalToast
        )
      );
    }

    // setOpenToast(true);
  };
  function toggleNotesModal() {
    setNotesModal(!notesModal);
  }
  const handleChangeDescription = (lrNo , e) => {
    console.log("handleChangeDescription",lrNo, e?.target?.value,e?.target);
    const newDesc = {...lrDescription}
    let newLrDesc = newDesc[lrNo]
    newLrDesc = e?.target?.value
    newDesc[lrNo] = newLrDesc
    setLrDescription(newDesc)
  }
  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <ModalBody
          // style={{height : "80vh"}}
          className="transactionModalBody"
          //   style={{ height: "80vh" }}
          //   style={{borderRadius : "10px"}}
        >
          <div className="closeBtnWithBackground" onClick={handleClose}>
            <SvgImage
              classname="close-btn-text"
              style={{ width: "10%", height: "10%" }}
              name="crossBtnWIthBackground"
              width="20%"
              height="20%"
            />
          </div>
          <div
            style={{ marginTop: " 30px" }}
            //   className="PGCollectionBox"
          >
            {" "}
            <div className="d-flex">
              <div className="PGCollectiontText" style={{ marginLeft: "50px" }}>
                Invoice Details
              </div>
              <div className="" style={{ margin: "2px 0 0 10px" }}>
                <input
                  type="text"
                  className="minBox3"
                  name="txt"
                  onChange={(e) => {
                    setInvoiceNo(e?.target.value);
                  }}
                  placeholder={fetchInvoiceNo || "Invoice No."}
                  autoComplete="off"
                />
              </div>
             
              <div onClick={() => setInovieSetting(true)}>
                <SvgImage name="settingsLogo" height="30" width="30" />
              </div>
              <div className="" style={{ margin: "2px 0 0 10px" }}>
              {/* <input
                  type="date"
                  className="minBox3"
                  name="txt"
                  onChange={(e) => {
                    setInvoiceDate(e?.target.value);
                  }}
                  value={invoiceDate}
                  placeholder={"Invoice Date"}
                  autoComplete="off"
                /> */}
                <DatePickerField
                  classname="searchBar-input1"
                  name="invoice Date"
                  header="Select invoice date"
                  value={invoiceDate}
                  onChange={(v) => {
                    console.log(v);
                    setInvoiceDate(v);
                  }}
                  showTimeInput={false}
                  style={{ width: "100px" }}
                  // showTimeInput={true}
                />
              </div>
            </div>
            <div>
              <Table
                className="TripSectionTable"
                bordered="true"
                id="driver_tables" //
                style={{ height: "30vh", marginTop: "20px" }}
              >
                <thead>
                  <tr className="table-header-trip p-0 align-middle text-center">
                    <th className="p-0" style={{ width: "15%" }}>
                      <div style={{ marginLeft: "10px" }}>S.No</div>
                    </th>
                    <th className="p-0" style={{ width: "30%" }}>
                      <div>Description</div>{" "}
                    </th>
                    <th className="p-0" style={{ width: "16%" }}>
                      HSN Code
                    </th>
                    <th className="p-0" style={{ width: "16%" }}>
                      Quantity
                    </th>
                    <th className="p-0" style={{ width: "16%" }}>
                      Amount
                    </th>
                    <th className="p-0" style={{ width: "10%" }}>
                      Total Amount
                    </th>
                    <th className="p-0" style={{ width: "5%" }}></th>
                  </tr>
                </thead>
                <tbody className="lowerBorderLineCust">
                  {tripSelect?.map((items, i) => {
                    console.log("jjahfksdjfoij", items);
                    let desc = lrDescription[items.lrNo]
                      ? `${items?.lrNo}- ${lrDescription[items.lrNo]}`
                      : items?.lrNo;
                    let viewDesc = items?.Fleet?.regNumber
                      ? desc + " - " + items?.Fleet?.regNumber
                      : desc;
                    
                    let ex = chargesFormValues[items?.lrNo]
                    let ch = deductionFormValues[items?.lrNo]
                    console.log("jijhierhi", chargesFormValues, deductionFormValues);
                    let totalFreightAmount = 0
                    let totalCharges = 0
                    let totalDeduction = 0
                    if(lrDataFormValue[items?.lrNo]?.length > 0)
                      lrDataFormValue[items?.lrNo].forEach(e => totalFreightAmount = totalFreightAmount + parseFloat((e?.quantity || 0) * (e?.amountPerQuantity || 0)))
                    if(ex?.length > 0 ) ex.forEach(e =>{ 
                      if(e.remarks == "Detention") totalCharges = totalCharges + (parseFloat(e?.amount || 0) * parseFloat(e?.diffDays || 0))
                      else totalCharges = totalCharges + parseFloat(e?.amount || 0) 
                    })
                    if(ch?.length > 0 ) ch.forEach(e => totalDeduction = totalDeduction + parseFloat(e?.amt || 0) )
                    return (                   
                      <div>
                        <tr
                          className="table-row-manage-trip-new text4 align-middle text-center p-0"
                          onClick={() => {
                            // window.location = "/Customers/" + 1;
                            //   navigate("/Customers/" + 1);
                          }}
                        >
                          <td
                            style={{
                              width: "15%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                            <div style={{ marginLeft: "10px" }}>{i + 1} {editLrData ? `- LR_${items.lrNo}` :""}</div>
                          </td>
                          <td
                            style={{
                              width: "30%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                            { !editLrData ? viewDesc :
                            <input
                              type="text"
                              className="minBox3"
                              name="desc"
                              value={lrDescription[items.lrNo] || ""}
                              onChange={(e) =>
                                handleChangeDescription(items.lrNo, e)
                              }
                            />}
                          </td>
                          <td
                            style={{
                              width: "16%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                            {/* {items?.Trip?.destination} */}
                          </td>
                          <td
                            style={{
                              width: "16%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                          </td>
                          <td
                            style={{
                              width: "16%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                          </td>
                          <td
                            style={{
                              width: "14%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                            {/* ₹{items?.freightAmount} */}
                          </td>
                          <td
                            style={{
                              width: "13%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                            {lrDataFormValue[items?.lrNo] && lrDataFormValue[items?.lrNo]?.length != 0 ? (
                              <div style={{display: "flex", flexDirection: "row", width:"70px"}}>
                               {!editLrData ? <div 
                                  onClick={() =>  {
                                      console.log("editLrDataeditLrData",editLrData);
                                      setEditLrData(!editLrData)
                                      }}
                                  style={{ }} >
                                  <SvgImage name="editLogo" width="25" height="25" />
                                </div> :
                                <div
                                className="inputBoxCust3"
                                onClick={() =>
                                  addFormFields(items?.lrNo)
                                }
                                style={{
                                  cursor: "pointer",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                +
                              </div>}
                              </div>
                           
                            ) : (
                              <div
                              className="inputBoxCust3"
                              onClick={() => {
                                setEditLrData(true)
                                addFormFields(items?.lrNo)
                              }}
                              style={{
                                cursor: "pointer",
                                textAlign: "center",
                                width: "70px"
                              }}
                            >
                              +
                            </div>
                            )}
                          </td>
                        </tr>
                        {lrDataFormValue[items?.lrNo]?.length > 0 && (
                          <Table
                            className=""
                            bordered="true"
                            id="" //
                            // style={{ height: "30vh", marginTop: "20px" }}
                          >
                            <tbody
                              style={
                                {
                                  // borderBottom:
                                  //   "0.1px solid rgba(108, 108, 108, 0.6)",
                                }
                              }
                            >
                              {lrDataFormValue[items?.lrNo]?.map((dd, ii) => {
                                return (
                                  <tr
                                    className="table-row-manage-trip-new text4 align-middle text-center p-0"
                                    onClick={() => {
                                      // window.location = "/Customers/" + 1;
                                      //   navigate("/Customers/" + 1);
                                    }}
                                  >
                                    <td
                                      style={{
                                        width: "15%",
                                        borderLeft: "1px solid transparent",
                                        borderRight: " 1px solid transparent",
                                      }}
                                      className="p-0"
                                    ></td>
                                    <td
                                      style={{
                                        width: "22%",
                                        borderLeft: "1px solid transparent",
                                        borderRight: " 1px solid transparent",
                                        display:"flex", flexDirection:"row"
                                      }}
                                      className="p-0"
                                    >
                                      <div style={!editLrData ? { marginRight: "10px" ,marginTop:"5px"}:{marginTop:"8px"}}>
                                        <span>{i + 1}.{ii + 1}</span><span>-</span> </div>
                                      <div>{!editLrData ? 
                                      <div style={!editLrData ? { marginTop:"5px"}:{}}> {`${dd?.desc}`} </div> : 
                                      <div  style={{
                                        width: "150px"}}>
                                        <input
                                          type="text"
                                          className="minBox3"
                                          name="desc"
                                          value={dd?.desc || ""}
                                          onChange={(e) =>
                                            handleChangeField(ii, e,items?.lrNo)
                                          }
                                        />
                                      </div>}
                                     </div>
                                    </td>
                                    <td
                                      style={{
                                        width: "16%",
                                        borderLeft: "1px solid transparent",
                                        borderRight: " 1px solid transparent",
                                        marginLeft:"100px"
                                      }}
                                      className="p-0"
                                    >
                                      -
                                    </td>
                                    <td
                                      style={{
                                        width: "16%",
                                        borderLeft: "1px solid transparent",
                                        borderRight: " 1px solid transparent",
                                      }}
                                      className="p-0"
                                    >
                                      <div>
                                      {!editLrData ? 
                                      <div> {`${dd?.quantity}`} </div> : 
                                      <div  style={{
                                        width: "100px", marginTop:"-10px"}}>
                                        <input
                                          type="number"
                                          className="minBox3"
                                          name="quantity"
                                          value={dd.quantity || ""}
                                          onChange={(e) =>
                                            handleChangeField(ii, e, items?.lrNo)
                                          }
                                        />
                                      </div>}
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        width: "16%",
                                        borderLeft: "1px solid transparent",
                                        borderRight: " 1px solid transparent",
                                      }}
                                      className="p-0"
                                    >
                                      <div>
                                      {!editLrData ? 
                                      <div> {`₹ ${dd?.amountPerQuantity}`} </div> : 
                                      <div  style={{
                                        width: "100px", marginTop:"-10px"}}>
                                        <input
                                          type="number"
                                          className="minBox3"
                                          name="amountPerQuantity"
                                          value={dd.amountPerQuantity || ""}
                                          onChange={(e) => {
                                            handleChangeField(ii, e,items?.lrNo);
                                          }}
                                        />
                                      </div>}
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        width: "10%",
                                        borderLeft: "1px solid transparent",
                                        borderRight: " 1px solid transparent",
                                      }}
                                      className="p-0"
                                    >
                                      ₹
                                      {parseFloat(dd?.amountPerQuantity || 0) *
                                        parseFloat(dd?.quantity || 1)}
                                    </td>
                                    <td
                                    style={{
                                      width: "5%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                    }}
                                    className="p-0"
                                    onClick={() => {
                                      removeFormFields(
                                        ii,
                                        items?.lrNo
                                      );
                                    }}
                                  >
                                    <SvgImage name="deleteIcon2" />
                                  </td>
                                  </tr>
                                );
                              })}
                              <tr>
                                <div className="d-flex justify-content-center">
                                  <div
                                    className="addItemDiv10"
                                    style={{
                                      width: "100%",
                                      alignContent: "center",
                                      textAlign: "left",
                                      padding: "0px",
                                    }}
                                    // onClick={() => addFormFieldsDeduction(items?.lrNo)}
                                  >
                                    Charges
                                    
                                  </div>

                                  <div
                                    className="inputBoxCust3"
                                    onClick={() =>
                                      addFormFieldsCharges(items?.lrNo)
                                    }
                                    style={{
                                      cursor: "pointer",
                                      textAlign: "center",
                                    }}
                                  >
                                    +
                                  </div>
                                </div>
                              </tr>
                            </tbody>
                          </Table>
                        )}
                        {ex?.length > 0 && (
                        <Table
                          className="TripSectionTable"
                          bordered="true"
                          id="driver_tables" //
                          // style={{ marginTop: "16px" }}
                        >
                          <tbody className="lowerBorderLineCust">
                            {ex?.map((element, index) => {
                              return (
                                <tr
                                  className="table-row-manage-trip-new text4 align-middle text-center p-0"
                                  id="addr0"
                                  key={index}
                                  onClick={() => {
                                    // window.location = "/Customers/" + 1;
                                    //   navigate("/Customers/" + 1);
                                  }}
                                >
                                  <td
                                    style={{
                                      // width: "7%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                    }}
                                    className="p-0 col-2"
                                  >
                                    <div style={{display: "flex", flexDirection: "row",marginLeft: "10px" }}>
                                    <div style={{ }}>
                                      Charges
                                      {/* {index + 1} */}
                                    </div>
                                    {element.amount && element?.remarks  ? <div style={{ marginTop:"-2px"  }}>
                                      {console.log()}
                                    <Button
                                      style={{
                                        // width: "80px",
                                        backgroundColor: "white",
                                        color: "#2E7C7B",
                                        marginLeft: "25px",
                                        borderColor: "#2E7C7B",
                                        fontSize:"12px",
                                        lineHeight:"13px",
                                        padding:"3px",
                                      }}
                                      onClick={addChargesToAll(element, index, items?.lrNo)}
                                    >
                                     Add To All
                                    </Button>
                                    </div> : <></>}
                                    </div>
                                   
                                  </td>
                                  <td
                                    style={{
                                      // width: "30%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                    }}
                                    className="p-0 col-2"
                                  >
                                    <input
                                      type="text"
                                      className="minBox3"
                                      name="remarks"
                                      value={element.remarks || ""}
                                      onChange={(e) => {
                                        handleChangeFieldCharges(
                                          index,
                                          e,
                                          items?.lrNo
                                        );
                                        setDisplay(
                                          `extra${index + items?.lrNo}`
                                        );
                                      }}
                                      onFocus={() => {
                                        setDisplay(
                                          `extra${index + items?.lrNo}`
                                        );
                                      }}
                                      onBlur={() => {
                                        setDisplay("");
                                      }}
                                      autoComplete="off"
                                    />
                                    <FormPicker
                                      placeholder="Search"
                                      // text="Select by driver name"
                                      listing={[
                                        "RTO",
                                        "Unloading",
                                        "Loading",
                                        "Detention",
                                        "Extra Load",
                                        "Insurance",
                                        "Entry",
                                      ]}
                                      parameter="Occupation"
                                      minWidth={"180"}
                                      // handlingDivSelect={handlingDivSelect}
                                      display={display}
                                      setDisplay={setDisplay}
                                      // displayVehicles={displayVehicles}
                                      // setDisplayVehicles={setDisplayVehicles}
                                      color={color}
                                      setColor={setColor}
                                      //   loading={loading}
                                      manualFunction={(i, item) => {
                                        console.log("kjjjiii", i, item);
                                        handleChangeFieldCharges(
                                          index,
                                          {
                                            target: {
                                              name: "remarks",
                                              value: item,
                                            },
                                          },
                                          items?.lrNo
                                        );
                                      }}
                                      header={`extra${index + items?.lrNo}`}
                                      autoComplete="off"
                                      // userId={userId}
                                      // setUserId={setUserId}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      width: "16%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                    }}
                                    className="p-0"
                                  >
                                    {/* <div style={{ marginLeft: "10px" }}>{i + 1}</div> */}
                                  </td>
                                  <td
                                    style={{
                                      width: "16%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                    }}
                                    className="p-0"
                                  >
                                    {element?.remarks == "Detention" ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div style={{ marginRight: "10px" }}>
                                          days
                                        </div>
                                        <div>
                                          <input
                                            type="number"
                                            className="minBox3"
                                            name="diffDays"
                                            style={{}}
                                            value={element.diffDays || ""}
                                            onChange={(e) =>
                                              handleChangeFieldCharges(
                                                index,
                                                e,
                                                items?.lrNo
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    ) : null}
                                  </td>
                                  <td
                                    style={{
                                      width: "16%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                    }}
                                    className="p-0"
                                  >
                                    {/* <div style={{ marginLeft: "10px" }}>{i + 1}</div> */}
                                    <input
                                      type="number"
                                      className="minBox3"
                                      name="amount"
                                      value={element.amount || ""}
                                      onChange={(e) =>
                                        handleChangeFieldCharges(
                                          index,
                                          e,
                                          items?.lrNo
                                        )
                                      }
                                    />
                                  </td>
                                  <td
                                    style={{
                                      width: "10%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                    }}
                                    className="p-0"
                                  >
                                    <div style={{ marginLeft: "10px" }}>
                                      {element?.remarks == "Detention"
                                        ? element.amount *
                                          (element.diffDays || 1)
                                        : element.amount}
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      width: "5%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                    }}
                                    className="p-0"
                                    onClick={() => {
                                      removeChargesFormFields(
                                        index,
                                        items?.lrNo
                                      );
                                    }}
                                  >
                                    <SvgImage name="deleteIcon2" />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                        )}
                        <div className="d-flex justify-content-center">
                          <div
                            className="addItemDiv10"
                            style={{
                              width: "100%",
                              alignContent: "center",
                              textAlign: "left",
                              padding: "0px",
                            }}
                            // onClick={() => addFormFieldsDeduction(items?.lrNo)}
                          >
                            Deductions
                          </div>

                          <div
                            className="inputBoxCust3"
                            onClick={() => addFormFieldsDeduction(items?.lrNo)}
                            style={{
                              cursor: "pointer",
                              textAlign: "center",
                            }}
                          >
                            +
                          </div>
                        </div>
                        {ch?.length > 0 && (
                          <Table
                            className=""
                            bordered="true"
                            id="" //
                            // style={{ height: "30vh", marginTop: "20px" }}
                          >
                            <tbody
                              style={{
                                borderBottom:
                                  "0.1px solid rgba(108, 108, 108, 0.6)",
                              }}
                            >
                              {ch?.map((dd, ii) => {
                                return (
                                  <>
                                    {
                                      <tr
                                        className="table-row-manage-trip-new text4 align-middle text-center p-0 "
                                        onClick={() => {
                                          // window.location = "/Customers/" + 1;
                                          //   navigate("/Customers/" + 1);
                                        }}
                                      >
                                        <td
                                          style={{
                                            // width: "7%",
                                            borderLeft: "1px solid transparent",
                                            borderRight:
                                              " 1px solid transparent",
                                            paddingLeft: "10px",
                                          }}
                                          className="p-0 col-2"
                                        >
                                          <div style={{display: "flex", flexDirection: "row",marginLeft: "10px" }}>
                                    <div style={{ }}>
                                      Deductions
                                      {/* {index + 1} */}
                                    </div>
                                    {dd.amt && dd?.txt ? <div style={{ marginTop:"-2px"  }}>
                                    <Button
                                      style={{
                                        // width: "80px",
                                        backgroundColor: "white",
                                        color: "#2E7C7B",
                                        marginLeft: "5px",
                                        borderColor: "#2E7C7B",
                                        fontSize:"12px",
                                        lineHeight:"13px",
                                        padding:"3px",
                                      }}
                                      onClick={addDeductionsToAll(dd, ii, items?.lrNo)}
                                    >
                                     Add To All
                                    </Button>
                                    </div> : <></>}
                                    </div>
                                        </td>
                                        <td
                                          style={{
                                            // width: "30%",
                                            borderLeft: "1px solid transparent",
                                            borderRight:
                                              " 1px solid transparent",
                                          }}
                                          className="p-0 col-2"
                                        >
                                          <div style={{}}>
                                            <div className="">
                                              {/* <div
                                                className="col-2"
                                                style={{
                                                  padding: "8px 0 0 8px",
                                                }}
                                              >
                                                {i + 1}.{ii + 1} -{" "}
                                              </div> */}
                                              <div className="">
                                                <input
                                                  type="text"
                                                  className="minBox3"
                                                  name="txt"
                                                  value={dd?.txt || ""}
                                                  onChange={(e) => {
                                                    handleChangeFieldDeduction(
                                                      ii,
                                                      e,
                                                      items?.lrNo
                                                    );
                                                    setDisplay(
                                                      `charge${
                                                        ii + items?.lrNo
                                                      }`
                                                    );
                                                  }}
                                                  onFocus={() => {
                                                    setDisplay(
                                                      `charge${
                                                        ii + items?.lrNo
                                                      }`
                                                    );
                                                  }}
                                                  onBlur={() => {
                                                    setDisplay("");
                                                  }}
                                                  autoComplete="off"
                                                />
                                                <FormPicker
                                                  placeholder="Search"
                                                  // text="Select by driver name"
                                                  listing={[
                                                    "Late Penalty",
                                                    "Shortage Fare",
                                                    "Shortage Freight",
                                                  ]}
                                                  parameter="Occupation"
                                                  minWidth={"180"}
                                                  // handlingDivSelect={handlingDivSelect}
                                                  display={display}
                                                  setDisplay={setDisplay}
                                                  // displayVehicles={displayVehicles}
                                                  // setDisplayVehicles={setDisplayVehicles}
                                                  color={color}
                                                  setColor={setColor}
                                                  //   loading={loading}
                                                  manualFunction={(i, item) => {
                                                    console.log(
                                                      "kjjjiii",
                                                      i,
                                                      item
                                                    );
                                                    handleChangeFieldDeduction(
                                                      ii,
                                                      {
                                                        target: {
                                                          name: "txt",
                                                          value: item,
                                                        },
                                                      },
                                                      items?.lrNo
                                                    );
                                                  }}
                                                  header={`charge${
                                                    ii + items?.lrNo
                                                  }`}
                                                  autoComplete="off"
                                                  // userId={userId}
                                                  // setUserId={setUserId}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            width: "16%",
                                            borderLeft: "1px solid transparent",
                                            borderRight:
                                              " 1px solid transparent",
                                          }}
                                          className="p-0"
                                        >
                                          -
                                        </td>
                                        <td
                                          style={{
                                            width: "16%",
                                            borderLeft: "1px solid transparent",
                                            borderRight:
                                              " 1px solid transparent",
                                          }}
                                          className="p-0"
                                        >
                                          -
                                        </td>
                                        <td
                                          style={{
                                            width: "16%",
                                            borderLeft: "1px solid transparent",
                                            borderRight:
                                              " 1px solid transparent",
                                          }}
                                          className="p-0"
                                        >
                                          {/* <input
                                            type="number"
                                            className="minBox3"
                                            name="amount"
                                            value={dd?.amount || ""}
                                            onChange={(e) =>
                                              handleChangeFieldCharges(
                                                ii,
                                                e,
                                                items?.lrNo
                                              )
                                            }
                                          /> */}
                                        </td>
                                        <td
                                          style={{
                                            width: "10%",
                                            borderLeft: "1px solid transparent",
                                            borderRight:
                                              " 1px solid transparent",
                                          }}
                                          className="p-0"
                                        >
                                          <input
                                            type="number"
                                            className="minBox3"
                                            name="amt"
                                            value={dd?.amt || ""}
                                            onChange={(e) => {
                                              console.log(
                                                "mkmnknkds",
                                                tripSelect
                                              );
                                              handleChangeFieldDeduction(
                                                ii,
                                                e,
                                                items?.lrNo
                                              );
                                            }}
                                          />
                                        </td>
                                        <td
                                          style={{
                                            width: "5%",
                                            borderLeft: "1px solid transparent",
                                            borderRight:
                                              " 1px solid transparent",
                                          }}
                                          className="p-0"
                                        >
                                          <div
                                            onClick={() =>
                                              removeDeductionFormFields(
                                                ii,
                                                items?.lrNo
                                              )
                                            }
                                            style={{
                                              cursor: "pointer",
                                              textAlign: "center",
                                            }}
                                          >
                                            <SvgImage name="deleteIcon2" />
                                          </div>
                                        </td>
                                      </tr>
                                    }
                                  </>
                                );
                              })}
                            </tbody>
                          </Table>
                        )}

                        <tr
                          className="table-row-manage-trip-new text4 align-middle text-center p-0 table-bordered"
                          onClick={() => {
                            // window.location = "/Customers/" + 1;
                            //   navigate("/Customers/" + 1);
                          }}
                        >
                          <td
                            style={{
                              width: "7%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                            {/* <div style={{ marginLeft: "10px" }}>{i + 1}</div> */}
                          </td>
                          <td
                            style={{
                              width: "30%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                            {/* {`${items?.lrNo} - ${items?.description}`} */}
                          </td>
                          <td
                            style={{
                              width: "16%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                            {/* {items?.Trip?.destination} */}
                          </td>
                          <td
                            style={{
                              width: "16%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                            {/* 1 */}
                          </td>
                          <td
                            style={{
                              width: "16%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                            {/* ₹{items?.freightAmount} */}
                          </td>
                          <td
                            style={{
                              width: "14%",
                              borderLeft: "1px solid transparent",
                              borderRight: " 1px solid transparent",
                            }}
                            className="p-0"
                          >
                            ₹
                            {parseFloat(totalFreightAmount || 0 ) +
                              parseFloat(totalCharges || 0) -
                              parseFloat(totalDeduction || 0)}
                          </td>
                        </tr>
                      </div>
                    );
                  })}
                </tbody>
              </Table>
              <Table
                className="TripSectionTable"
                bordered="true"
                id="driver_tables" //
                // style={{ height: "30vh" }}
              >
                <thead>
                  <tr className="table-header-trip p-0 align-middle text-center">
                    <th className="p-0" style={{ width: "10%" }}>
                      <div style={{ marginLeft: "10px" }}>Sub Total</div>
                    </th>
                    <th className="p-0" style={{ width: "30%" }}></th>
                    <th className="p-0" style={{ width: "16%" }}></th>
                    <th className="p-0" style={{ width: "16%" }}>
                      {quantity}
                    </th>
                    <th className="p-0" style={{ width: "14%" }}>
                      {/* ₹{subTotal} */}
                    </th>
                    <th className="p-0" style={{ width: "16%" }}>
                        ₹ {parseFloat(total) ||  0}
                    </th>
                  </tr>
                </thead>
              </Table>
              <Table
                className="TripSectionTable"
                bordered="true"
                id="driver_tables" //
                // style={{ height: "30vh" }}
              >
                <thead>
                  <tr className="table-header-trip p-0 align-middle text-center">
                    <th className="p-0" style={{ width: "30%" }}>
                      <div style={{ marginLeft: "10px" }}>Taxable/Discount ( Only Freight Amount)</div>
                    </th>
                    <th className="p-0" style={{ width: "5%" }}></th>
                    <th className="p-0" style={{ width: "5%" }}></th>
                    <th className="p-0" style={{ width: "30%" }}>
                      <div className="row">
                        <div className="col-1">
                          <input
                            type="checkbox"
                            value={true}
                            // disabled={!radioBtn}
                            onClick={() => {
                              setTaxable(!taxable);
                            }}
                          />
                        </div>
                        <div className="col-11">Change To SubTotal</div>
                      </div>
                    </th>
                    <th className="p-0" style={{ width: "14%" }}>
                     
                    </th>
                    <th className="p-0" style={{ width: "16%" }}>
                        ₹ {(!taxable ? (parseFloat(total) - parseFloat(extraTotal) + parseFloat(deductionTotal)) :  parseFloat(total)) || 0}
                    </th>
                  </tr>
                </thead>
              </Table>
              <div className="table-Div">
                <Table
                  className="TripSectionTable"
                  bordered="true"
                  id="driver_tables" //
                  // style={{ height: "30vh" }}
                >
                  <thead>
                    <tr className="table-header-trip-without-color p-0 align-middle text-center">
                      <th className="p-0" style={{ width: "30%" }}>
                        <div style={{ marginLeft: "16px" }}>Discount</div>
                      </th>
                      <th className="p-0" style={{ width: "10%" }}></th>
                      <th className="p-0" style={{ width: "16%" }}></th>
                      <th className="p-0" style={{ width: "16%" }}></th>
                      <th className="p-0" style={{ width: "14%" }}>
                        <input
                          type="number"
                          className="minBox"
                          placeholder="0%"
                          min="0"
                          max={"100"}
                          pattern="[0-9]{2}"
                          value={discountPercent ? discountPercent : ""}
                          onChange={(e) => {
                            console.log("====vvvvv", e.target.value);
                            if (e.target.value && (parseFloat(e.target.value) < 0 || parseFloat(e.target.value) > 100)) {
                              return
                            }
                            else if (e.target.value && e.target.value == "0") {
                              setDiscountPercent(0);
                              setDiscount(0);
                            } else {
                              setDiscountPercent(e.target.value);
                              let temp = (!taxable ? (parseFloat(total) - parseFloat(extraTotal) + parseFloat(deductionTotal)) :  parseFloat(total)) * (parseFloat(e.target.value) / 100);
                              setDiscount(temp.toFixed(2));
                              setDiscountPercentFinally(true)
                              // setTotal(parseFloat(total) - (parseFloat(total) *  (parseFloat(e.target.value)/100)));
                            }
                          }}
                        />

                        {discountPercent ? "%" : ""}
                      </th>
                      <th className="p-0" style={{ width: "16%" }}>
                        <input
                          type="number"
                          className="minBox2"
                          placeholder="₹ 0"
                          min="0"
                          max={total}
                          value={discount ? discount : ""}
                          onChange={(e) => {
                            console.log("====vvvvv", e.target.value);
                            if (e.target.value && (parseFloat(e.target.value) < 0 || parseFloat(e.target.value) > parseFloat(total || 0))) {
                              return
                            }
                            else if (e.target.value && e.target.value == "0") {
                              setDiscount(0);
                              setDiscountPercent(0);
                            } else {
                               // setTotal(parseFloat(total) - parseFloat(e.target.value));
                               setDiscount(e.target.value);
                               let temp = (parseFloat(e.target.value) / (!taxable ? (parseFloat(total) - parseFloat(extraTotal) + parseFloat(deductionTotal)) :  parseFloat(total))) * 100;
                               setDiscountPercent(temp.toFixed(2));
                               setDiscountPercentFinally(false)
                            }
                          }}
                        />
                      </th>
                    </tr>
                    <tr className="table-header-trip-without-color p-0 align-middle text-center">
                      <th className="p-0" style={{ width: "30%" }}>
                        <div style={{ marginLeft: "16px" }}>Extra charges</div>
                      </th>
                      <th className="p-0" style={{ width: "10%" }}></th>
                      <th className="p-0" style={{ width: "16%" }}></th>
                      <th className="p-0" style={{ width: "16%" }}></th>
                      <th className="p-0" style={{ width: "14%" }}>
                        {/* {discountPercent ? "%" : ""} */}
                      </th>
                      <th className="p-0" style={{ width: "16%" }}>
                        <input
                          type="number"
                          className="minBox2"
                          placeholder="₹ 0"
                          min="0"
                          max={total}
                          value={extraCharges ? extraCharges : ""}
                          onChange={(e) => {
                            console.log("====vvvvv", e.target.value);
                            if (e.target.value && (parseFloat(e.target.value) < 0 || parseFloat(e.target.value) > parseFloat(total || 0))) {
                              return
                            }
                            else if (e.target.value && e.target.value == "0") {
                              setExtraCharges(0);
                            } else {
                              setExtraCharges(e.target.value);
                            }
                          }}
                        />
                      </th>
                    </tr>
                  </thead>
                </Table>
              </div>
              <div className="table-Div">
                {" "}
                <Table
                  className="TripSectionTable"
                  bordered="true"
                  id="driver_tables" //
                  // style={{ height: "30vh" }}
                >
                  <thead style={{ marginLeft: "20px" }}>
                    <tr className="table-header-trip-without-color p-0 align-middle text-center">
                      <th className="p-0" style={{ width: "4%" }}>
                        <div>
                          <input
                            type="radio"
                            checked={radioBtn}
                            onChange={(e) => {
                              console.log("===<<<<<nmtknikn1");
                              setRadioBtn(true);
                            }}
                          />
                        </div>
                      </th>
                      <th className="p-0" style={{ width: "15%" }}>
                        <div style={{ marginLeft: "10px" }}>Taxes</div>
                      </th>
                      <th className="p-0" style={{ width: "20%" }}>
                        IGST
                      </th>
                      <th className="p-0" style={{ width: "35%" }}>
                        <div className="row">
                          <div className="col-1">
                            <input
                              type="checkbox"
                              value={igstAdded}
                              disabled={!radioBtn}
                              onClick={() => {
                                setIgstAdded(!igstAdded);
                              }}
                            />
                          </div>
                          <div className="col-10">Added in Freight Amount</div>
                        </div>
                      </th>
                      <th className="p-0" style={{ width: "14%" }}>
                        <input
                          type="number"
                          className="minBox"
                          placeholder="0%"
                          min="0"
                          max={"100"}
                          disabled={igstAdded || !radioBtn}
                          value={
                            !igstAdded && taxesIGSTPercent
                              ? taxesIGSTPercent
                              : ""
                          }
                          onChange={(e) => {
                            console.log("====vvvvv", e.target.value);
                            if (e.target.value && e.target.value != "0") {
                              // setTotal(parseFloat(total) + (parseFloat(total) * (parseFloat(e.target.value)/100)));
                              settaxesIGSTPercent(e.target.value);
                              let temp =
                                ((!taxable ? (parseFloat(total) - parseFloat(extraTotal) + parseFloat(deductionTotal)) :  parseFloat(total)) - parseFloat(discount || 0) +  parseFloat(extraCharges || 0)) * (parseFloat(e.target.value) / 100);
                              console.log("asdfgasdf", temp, temp.toFixed(2));
                              settaxesIGST(temp.toFixed(2));
                              setIgstPercentFinally(true)

                            } else {
                              settaxesIGSTPercent(0);
                              settaxesIGST(0);
                            }
                          }}
                        />
                        {taxesIGSTPercent ? "%" : ""}
                      </th>
                      <th className="p-0" style={{ width: "16%" }}>
                        <input
                          type="number"
                          className="minBox2"
                          placeholder="₹ 0"
                          min="0"
                          disabled={igstAdded || !radioBtn}
                          max={total}
                          value={!igstAdded && taxesIGST ? taxesIGST : ""}
                          onChange={(e) => {
                            console.log("====vvvvv", e.target.value);
                            if (e.target.value && e.target.value != "0") {
                              // setTotal(parseFloat(total) + parseFloat(e.target.value));
                              settaxesIGST(e.target.value);
                              let temp =
                                (parseFloat(e.target.value) / ((!taxable ? (parseFloat(total) - parseFloat(extraTotal) + parseFloat(deductionTotal)) :  parseFloat(total)) -  parseFloat(discount || 0) + parseFloat(extraCharges || 0))) * 100;
                              settaxesIGSTPercent(temp.toFixed(2));   
                              setIgstPercentFinally(false)
                            } else {
                              settaxesIGST(0);
                              settaxesIGSTPercent(0);
                            }
                          }}
                        />
                      </th>
                    </tr>
                  </thead>
                </Table>
              </div>
              <div className="table-Div">
                {" "}
                <Table
                  className="TripSectionTable"
                  bordered="true"
                  id="driver_tables" //
                  // style={{ height: "30vh" }}
                >
                  <thead style={{ marginLeft: "20px", width: "100%" }}>
                    <tr className="table-header-trip-without-color p-0 align-middle text-center">
                      <th className="p-0" style={{ width: "4%" }}>
                        <div>
                          <input
                            type="radio"
                            checked={!radioBtn}
                            onChange={(e) => {
                              console.log("===<<<<<nmtknikn1");
                              setRadioBtn(false);
                            }}
                          />
                        </div>
                      </th>
                      <th className="p-0" style={{ width: "15%" }}>
                        <div style={{ marginLeft: "10px" }}>Taxes</div>
                      </th>
                      <th className="p-0" style={{ width: "20%" }}>
                        CGST
                      </th>
                      <th className="p-0" style={{ width: "35%" }}>
                        <div className="row">
                          <div className="col-1">
                            <input
                              type="checkbox"
                              value={cgstAdded}
                              disabled={radioBtn}
                              onClick={() => {
                                setCgstAdded(!cgstAdded);
                              }}
                            />
                          </div>
                          <div className="col-10">Added in Freight Amount</div>
                        </div>
                      </th>
                      <th className="p-0" style={{ width: "14%" }}>
                        <input
                          type="number"
                          className="minBox"
                          placeholder="0%"
                          min="0"
                          max={"100"}
                          disabled={cgstAdded || radioBtn}
                          value={
                            !cgstAdded && taxesCGSTPercent
                              ? taxesCGSTPercent
                              : ""
                          }
                          onChange={(e) => {
                            console.log("====vvvvv", e.target.value);
                            if (e.target.value && e.target.value != "0") {
                              // setTotal(parseFloat(total) + (parseFloat(total) * (parseFloat(e.target.value)/100)));
                              settaxesCGSTPercent(e.target.value);
                              let temp =
                                ((!taxable ? (parseFloat(total) - parseFloat(extraTotal) + parseFloat(deductionTotal)) :  parseFloat(total)) -
                                  parseFloat(discount || 0) +
                                  parseFloat(extraCharges || 0)) *
                                (parseFloat(e.target.value) / 100);
                              console.log("asdfgasdf", temp, temp.toFixed(2));
                              settaxesCGST(temp.toFixed(2));
                              setCgstPercentFinally(true)
                            } else {
                              settaxesCGSTPercent(0);
                              settaxesCGST(0);
                            }
                          }}
                        />
                        {taxesCGSTPercent ? "%" : ""}
                      </th>
                      <th className="p-0" style={{ width: "16%" }}>
                        <input
                          type="number"
                          className="minBox2"
                          placeholder="₹ 0"
                          min="0"
                          disabled={cgstAdded || radioBtn}
                          max={total}
                          value={!cgstAdded && taxesCGST ? taxesCGST : ""}
                          onChange={(e) => {
                            console.log("====vvvvv", e.target.value);
                            if (e.target.value && e.target.value != "0") {
                              // setTotal(parseFloat(total) + parseFloat(e.target.value));
                              settaxesCGST(e.target.value);
                              let temp =
                                (parseFloat(e.target.value) /
                                  ((!taxable ? (parseFloat(total) - parseFloat(extraTotal) + parseFloat(deductionTotal)) :  parseFloat(total)) -
                                    parseFloat(discount || 0) +
                                    parseFloat(extraCharges || 0))) *
                                100;
                              settaxesCGSTPercent(temp.toFixed(2));
                              setCgstPercentFinally(false)
                            } else {
                              settaxesCGST(0);
                              settaxesCGSTPercent(0);
                            }
                          }}
                        />
                      </th>
                    </tr>
                    <tr className="table-header-trip-without-color p-0 align-middle text-center">
                      <th className="p-0" style={{ width: "4%" }}>
                        <div></div>
                      </th>
                      <th className="p-0" style={{ width: "15%" }}>
                        <div style={{ marginLeft: "10px" }}>Taxes</div>
                      </th>
                      <th className="p-0" style={{ width: "20%" }}>
                        SGST
                      </th>
                      <th className="p-0" style={{ width: "35%" }}>
                        <div className="row">
                          <div className="col-1">
                            <input
                              type="checkbox"
                              value={sgstAdded}
                              disabled={radioBtn}
                              onClick={() => {
                                setSgstAdded(!sgstAdded);
                              }}
                            />
                          </div>
                          <div className="col-10">Added in Freight Amount</div>
                        </div>
                      </th>
                      <th className="p-0" style={{ width: "14%" }}>
                        <input
                          type="number"
                          className="minBox"
                          placeholder="0%"
                          min="0"
                          max={"100"}
                          disabled={sgstAdded || radioBtn}
                          value={
                            !sgstAdded && taxesSGSTPercent
                              ? taxesSGSTPercent
                              : ""
                          }
                          onChange={(e) => {
                            console.log("====vvvvv", e.target.value);
                            if (e.target.value && e.target.value != "0") {
                              // setTotal(parseFloat(total) + (parseFloat(total) * (parseFloat(e.target.value)/100)));
                              settaxesSGSTPercent(e.target.value);
                              let temp =
                                ((!taxable ? (parseFloat(total) - parseFloat(extraTotal) + parseFloat(deductionTotal)) :  parseFloat(total)) -
                                  parseFloat(discount || 0) +
                                  parseFloat(extraCharges || 0)) *
                                (parseFloat(e.target.value) / 100);
                              console.log("asdfgasdf", temp, temp.toFixed(2));
                              settaxesSGST(temp.toFixed(2));
                              setSgstPercentFinally(true)

                            } else {
                              settaxesSGSTPercent(0);
                              settaxesSGST(0);
                            }
                          }}
                        />
                        {taxesSGSTPercent ? "%" : ""}
                      </th>
                      <th className="p-0" style={{ width: "16%" }}>
                        <input
                          type="number"
                          className="minBox2"
                          placeholder="₹ 0"
                          min="0"
                          disabled={sgstAdded || radioBtn}
                          max={total}
                          value={!sgstAdded && taxesSGST ? taxesSGST : ""}
                          onChange={(e) => {
                            console.log("====vvvvv", e.target.value);
                            if (e.target.value && e.target.value != "0") {
                              // setTotal(parseFloat(total) + parseFloat(e.target.value));
                              settaxesSGST(e.target.value);
                              let temp =
                                (parseFloat(e.target.value) /
                                  ((!taxable ? (parseFloat(total) - parseFloat(extraTotal) + parseFloat(deductionTotal)) :  parseFloat(total)) -
                                    parseFloat(discount || 0) +
                                    parseFloat(extraCharges || 0))) *
                                100;
                              settaxesSGSTPercent(temp.toFixed(2));
                              setSgstPercentFinally(false)
                            } else {
                              settaxesSGST(0);
                              settaxesSGSTPercent(0);
                            }
                          }}
                        />
                      </th>
                    </tr>
                  </thead>
                </Table>
              </div>

              <Table
                className="TripSectionTable"
                bordered="true"
                id="driver_tables" //
                // style={{ height: "30vh" }}
              >
                <thead>
                  <tr className="table-header-trip p-0 align-middle text-center">
                    <th className="p-0" style={{ width: "10%" }}>
                      <div style={{ marginLeft: "10px" }}>Total</div>
                    </th>
                    <th className="p-0" style={{ width: "30%" }}></th>
                    <th className="p-0" style={{ width: "16%" }}></th>
                    <th className="p-0" style={{ width: "16%" }}></th>
                    <th className="p-0" style={{ width: "14%" }}>
                      {/* ₹{total && total != "0" ? total.toFixed(2) : "0"} */}
                    </th>
                    <th className="p-0" style={{ width: "16%" }}>
                      ₹
                      {finalTotal && finalTotal != "0"
                        ? (
                            parseFloat(total) -
                            (parseFloat(discount || 0) -
                              parseFloat(extraCharges || 0) -
                              (radioBtn
                                ? parseFloat(!igstAdded ? taxesIGST || 0 : 0)
                                : parseFloat(!cgstAdded ? taxesCGST || 0 : 0) +
                                  parseFloat(!sgstAdded ? taxesSGST || 0 : 0)))
                          )?.toFixed(2)
                        : "0"}
                    </th>
                  </tr>
                </thead>
              </Table>
              {ledger && ledger?.length > 0 ? (
                <Table
                  className=""
                  bordered="true"
                  id="" //
                  // style={{ height: "30vh", marginTop: "20px" }}
                >
                  <tbody
                    style={{
                      borderBottom: "0.1px solid rgba(108, 108, 108, 0.6)",
                    }}
                  >
                    {ledger?.map((items, ii) => {
                      {console.log("ledgerledgerledger",items?.amount)}

                      return (
                        <>
                          {
                            <tr
                              className="table-row-manage-trip-new text4 align-middle text-center p-0"
                              onClick={() => {
                                // window.location = "/Customers/" + 1;
                                //   navigate("/Customers/" + 1);
                              }}
                            >
                              <td
                                style={{
                                  width: "7%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                }}
                                className="p-0"
                              >
                                {" "}
                                Advance
                              </td>
                              <td
                                style={{
                                  width: "30%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                }}
                                className="p-0"
                              >
                                <div style={{ marginLeft: "10px" }}>
                                  <div className="row">
                                    <div
                                      className="col-2"
                                      style={{
                                        padding: "8px 0 0 8px",
                                      }}
                                    >
                                      {ii + 1} -{" "}
                                    </div>
                                    <div className="col-8">
                                      <input
                                        type="text"
                                        className="minBox3"
                                        name="txt"
                                        value={
                                          items?.remarks ||
                                          items?.description ||
                                          ""
                                        }
                                        autoComplete="off"
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td
                                style={{
                                  width: "16%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                }}
                                className="p-0"
                              >
                                -
                              </td>
                              <td
                                style={{
                                  width: "16%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                }}
                                className="p-0"
                              >
                                -
                              </td>
                              <td
                                style={{
                                  width: "16%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                }}
                                className="p-0"
                              >
                                {/* <input
                                          type="number"
                                          className="minBox3"
                                          name="amount"
                                          value={dd?.amount || ""}
                                          onChange={(e) =>
                                            handleChangeFieldCharges(
                                              ii,
                                              e,
                                              items?.lrNo
                                            )
                                          }
                                        /> */}
                              </td>
                              <td
                                style={{
                                  width: "10%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                }}
                                className="p-0"
                              >
                                <input
                                  type="text"
                                  className="minBox3"
                                  name="amt"
                                  // value={10000}
                                  value={`₹ ${parseFloat(items?.amount || 0) || 0}`}
                                  disabled={true}
                                />
                              </td>
                              <td
                                style={{
                                  width: "5%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                }}
                                className="p-0"
                              >
                                <div
                                  onClick={() => {
                                    let f = ledger?.find(
                                      (e) => e?.ledgerId == items?.ledgerId
                                    );
                                    console.log("knkdsnifhis", f);
                                    if (f) {
                                      setExtraDeduction(
                                        parseFloat(extraDeduction) -
                                          parseFloat(items?.amount)
                                      );
                                      let n = ledger?.filter(
                                        (e) => e?.ledgerId != items?.ledgerId
                                      );
                                      console.log("knkdsnifhis", n);
                                      setLedger(n);
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                >
                                  <SvgImage name="deleteIcon2" />
                                </div>
                              </td>
                            </tr>
                          }
                        </>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <></>
              )}
              <Table
                className="TripSectionTable"
                bordered="true"
                id="driver_tables" //
                // style={{ height: "30vh" }}
              >
                <thead>
                  <tr className="table-header-trip p-0 align-middle text-center">
                    <th className="p-0" style={{ width: "25%" }}>
                      <div style={{ marginLeft: "10px" }}>
                        Add Advance Received
                      </div>
                    </th>
                    {/* <th className="p-0" style={{ width: "15%" }}>
                      <div style={{ marginLeft: "10px" }}>Received</div>
                    </th>
                    <th className="p-0" style={{ width: "20%" }}>
                      <input
                        type="number"
                        className="minBox2"
                        placeholder="₹ 0"
                        min="0"
                        max={total}
                        value={
                          extraDeduction && extraDeduction != "0"
                            ? extraDeduction
                            : ""
                        }
                        onChange={(e) => {
                          console.log("====vvvvv", e.target.value);
                          if (e.target.value && e.target.value != "0") {
                            // setTotal(parseFloat(total) - parseFloat(e.target.value));
                            setExtraDeduction(e.target.value);
                          } else {
                            setExtraDeduction(0);
                          }
                          if (ledger) setLedger(null);
                        }}
                      />
                    </th> */}
                    {/* <th className="p-0" style={{ width: "35%" }}>
                      select From Exist
                    </th> */}
                    <th className="p-0" style={{ width: "50%" }}>
                      <div onClick={(e) => setSelectTransactionModal(true)}>
                        <input
                          type="number"
                          className="minBox2"
                          placeholder="₹ 0"
                          min="0"
                          max={total}
                          value={"₹"}
                          style={{
                            width: "400px",
                          }}
                          // onChange={(e) => {
                          //   // setSelectTransactionModal(true);
                          // }}
                          // onFocus={(e) => setSelectTransactionModal(true)}
                        />
                      </div>
                    </th>
                    {/* <th className="p-0" style={{ width: "3%" }}></th> */}

                    <th className="p-0" style={{ width: "9%" }}></th>
                    <th className="p-0" style={{ width: "11%" }}>
                      <div>
                        <div
                          className="inputBoxCust2"
                          onClick={() => {
                            setAddLedger(true);
                          }}
                          style={{
                            cursor: "pointer",
                            textAlign: "center",
                          }}
                        >
                          +
                        </div>
                      </div>
                    </th>
                    <th className="p-0" style={{ width: "5%" }}></th>
                  </tr>
                </thead>
              </Table>
              <Table
                className="TripSectionTable"
                bordered="true"
                id="driver_tables" //
                // style={{ height: "30vh" }}
              >
                <thead>
                  <tr className="table-header-trip p-0 align-middle text-center">
                    <th className="p-0" style={{ width: "10%" }}>
                      <div style={{ marginLeft: "10px" }}>Net Pay</div>
                    </th>
                    {/* <th className="p-0" style={{ width: "15%" }}>
                      <div style={{ marginLeft: "10px" }}>Received</div>
                    </th>
                    <th className="p-0" style={{ width: "20%" }}>
                      <input
                        type="number"
                        className="minBox2"
                        placeholder="₹ 0"
                        min="0"
                        max={total}
                        value={
                          extraDeduction && extraDeduction != "0"
                            ? extraDeduction
                            : ""
                        }
                        onChange={(e) => {
                          console.log("====vvvvv", e.target.value);
                          if (e.target.value && e.target.value != "0") {
                            // setTotal(parseFloat(total) - parseFloat(e.target.value));
                            setExtraDeduction(e.target.value);
                          } else {
                            setExtraDeduction(0);
                          }
                          if (ledger) setLedger(null);
                        }}
                      />
                    </th> */}
                    {/* <th className="p-0" style={{ width: "35%" }}>
                      select From Exist
                    </th> */}
                    <th className="p-0" style={{ width: "40%" }}></th>
                    <th className="p-0" style={{ width: "3%" }}></th>

                    <th className="p-0" style={{ width: "8%" }}></th>
                    <th className="p-0" style={{ width: "19%" }}></th>
                    <th className="p-0" style={{ width: "16%" }}>
                      {console.log("kknkndks", parseFloat(extraDeduction || 0))}
                      ₹
                      {total && total != "0"
                        ? (
                            parseFloat(total) -
                            (parseFloat(discount || 0) -
                              parseFloat(extraCharges || 0) +
                              parseFloat(extraDeduction || 0) -
                              (radioBtn
                                ? parseFloat(!igstAdded ? taxesIGST || 0 : 0)
                                : parseFloat(!cgstAdded ? taxesCGST || 0 : 0) +
                                  parseFloat(!sgstAdded ? taxesSGST || 0 : 0)))
                          )?.toFixed(2)
                        : "0"}
                    </th>
                  </tr>
                </thead>
              </Table>
              <div
                style={{
                  padding: "25px 0 0 0",
                  textAlign: "center",
                }}
              >
                <Button
                  style={{
                    width: "160px",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    color: "#2E7C7B",
                    marginRight: 24,
                    borderColor: "#2E7C7B",
                  }}
                  className="generateOtp textAddCust Medium btn btn-secondary"
                  onClick={() => {
                    setNotesModal(true);
                  }}
                >
                  {textNote.length > 0 ? "Edit Notes" : "Add Notes"}
                </Button>
                <Button
                  type="submit"
                  style={{ width: "160px", borderRadius: "5px" }}
                  className="generateOtp textAddCust Medium btn btn-secondary"
                  onClick={() => {
                    setVersion(null);
                    setConfirmationModal(true);
                  }}
                >
                  Submit
                </Button>
              </div>
            </div>
            
          </div>
        </ModalBody>
      </Modal>

      {/* {toastObject.toastStatus ? (
        <InvoiceToast
          success={toastObject?.status}
          message={toastObject?.message}
          toggleModal={() => {
            setOpenToast(false);
          }}
          link={link}
          isOpen={toastObject?.toastStatus}
          name="driver"
          date={link}
          handleClose={() => {
            dispatch(
              toastStatus({
                toastStatus: false,
                message: "",
                status: true,
              })
            );

            window.location = `/Customers/${customerId}`;
            // navigate("/Customers");
          }}
        />
      ) : (
        <></>
      )} */}
      <NotesModal
        toggle={toggleNotesModal}
        setModal={setNotesModal}
        modal={notesModal}
        setTextNote={setTextNote}
        textNote={textNote}
      />
      {selectTransactionModal ? (
        <LedgerList
          open={selectTransactionModal}
          onHide={() => {
            setSelectTransactionModal(false);
          }}
          toggleModal={() => {
            setSelectTransactionModal(!selectTransactionModal);
          }}
          handleClose={() => {
            setSelectTransactionModal(false);
          }}
          ledger={ledger}
          setExtraDeduction={setExtraDeduction}
          extraDeduction={extraDeduction}
          setLedger={setLedger}
          onClickItem={(data) => {
            console.log("nknknihih", ledger);
            // setExtraDeduction(data?.amount);
            // setLedger([...ledger,data]);
            // setSelectTransactionModal(false);
            // setVendorData({});
            // setVendorData(data);
            // setSelectVendorModal(false);
            // let newFormValues = [...advancePayment];
            // newFormValues[selectedIndex]["vendor"] = { ...data };
            // setSelectedIndex(0);
            // setAdvancePayment(newFormValues);
          }}
          search={search}
          setSearch={setSearch}
        />
      ) : (
        <></>
      )}
      {addLedger ? (
        <AddLedgerEntry
          open={addLedger}
          customerId={customerId}
          onHide={() => {
            setAddLedger(false);
          }}
          toggleModal={() => {
            setAddLedger(!addLedger);
          }}
          handleClose={() => {
            setAddLedger(false);
          }}
          onSubmit={(data) => {
            const handleCloseToast = () => {
              setAddLedger(false);
              dispatch(
                toastStatus({
                  toastStatus: false,
                })
              );
            };
            const toggleModalToast = () => {
              setAddLedger(false);
              dispatch(
                toastStatus({
                  toastStatus: false,
                })
              );
            };
            dispatch(
              addPaymentRecivedAction(
                data,
                (resp) => {
                  console.log("jkahaihihfs", resp);
                  if (resp?.data?.type == "success") {
                    setExtraDeduction(
                      extraDeduction + parseFloat(data?.amount)
                    );
                    setLedger([...ledger, resp?.data?.data]);
                  }
                },
                handleCloseToast,
                toggleModalToast
              )
            );
            // setVendorData({});
            // setVendorData(data);
            // setSelectVendorModal(false);
            // let newFormValues = [...advancePayment];
            // newFormValues[selectedIndex]["vendor"] = { ...data };
            // setSelectedIndex(0);
            // setAdvancePayment(newFormValues);
          }}
          search={search}
          setSearch={setSearch}
        />
      ) : (
        <></>
      )}

      {confirmationModal ? (
        <ConfirmationModal
          isOpen={confirmationModal}
          toggleModal={() => {
            setConfirmationModal(!confirmationModal);
          }}
          onHide={() => {
            setConfirmationModal(false);
          }}
          handleClose={() => {
            setConfirmationModal(false);
          }}
          onPress={(version) => {
            handleToast(version);
            // dispatch(
            //   deleteBranch({ branchId: branchId }, (res) => {
            //     setConfirmationModal(false);
            //     if (res?.status == 200) {
            //     } else {

            //     }
            //   })
            // );
          }}
          msg={"Please select the invoice format"}
          setVersion={setVersion}
          version={version}
          loader={loader}
        />
      ) : (
        <></>
      )}

{inovieSetting ? (
        <InvoiceSettingModal
          isOpen={inovieSetting}
          toggleModal={() => {
            setInovieSetting(!inovieSetting);
          }}
          onHide={() => {
            setInovieSetting(false);
          }}
          handleClose={() => {
            setInovieSetting(false);
          }}
          onPress={(e) => {
            dispatch(
              getInvoiceNoAction({invoiceNo : e}, (res) => {
                console.log("jsdjnifjeirj",res?.data)
                setFetchInvoiceNo(res?.data?.data)
                setInovieSetting(false);
              },null,null)
            );
          }}
          setVersion={setVersion}
          version={version}
          loader={loader}
          fetchInvoiceNo={fetchInvoiceNo}
        />
      ) : (
        <></>
      )}
    </div>
  );
}

export default TripInvoiceDetail;
